/** Abreviaturas de mes en espanol para los ejes de fecha de los widgets (Highcharts). */
export const SPANISH_SHORT_MONTHS = [
  'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic',
];
